import { useState, useRef } from 'react'

const gridCards = {
  display: 'grid',
  gap: 10,
  gridTemplateColumns: 'repeat(3, 1fr)',
  position: 'relative'
}

const statCard = {
  background: '#fff',
  border: '1px solid #d4d4d4',
  borderRadius: 10,
  padding: '12px 14px',
  cursor: 'default'
}

const statCardLabel = {
  fontSize: 15,
  marginBottom: 8
}

const statCardValue = {
  fontSize: 23,
  fontWeight: 800,
  color: '#1e3f44'
}

const tooltipPopup = {
  position: 'fixed',
  transform: 'translateX(-50%)',
  background: 'rgba(0,0,0,0.85)',
  color: '#E7DFEC',
  borderRadius: 10,
  fontSize: 13,
  lineHeight: 1.35,
  padding: '8px 10px',
  pointerEvents: 'none',
  zIndex: 5000,
  whiteSpace: 'pre-line',
  boxShadow: '0 8px 20px rgba(0, 0, 0, 0.35)'
}

const StatCard = ({ label, value, onMouseEnter, onMouseLeave, onMouseMove }) => (
  <div style={statCard} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} onMouseMove={onMouseMove}>
    <div style={statCardLabel}>{label}</div>
    <div style={statCardValue}>{value}</div>
  </div>
)

const StatsOverviewModal = ({ stats, t, fmtNum, filterContext }) => {
  const [tooltip, setTooltip] = useState(null)
  const [cursorPos, setCursorPos] = useState({ x: 0, y: 0 })
  const hideTimerRef = useRef(null)
  const disabledRef = useRef(false)

  const makeTooltipText = (label) => {
    const vehicleText = filterContext?.vehicleName || t('TRIPLOG.BUTTON.ALL_VEHICLES')
    const periodText = stats?.tripsPeriodText || '-'
    const forVehicle = t('TRIPLOG.STATISTICS.SUMMARY.FOR_VEHICLE', { defaultValue: 'pre' })
    const forPeriod = t('TRIPLOG.STATISTICS.SUMMARY.FOR_PERIOD', { defaultValue: 'za' })
    return `${label}\n${forVehicle} ${vehicleText} ${forPeriod} ${periodText}`
  }

  const bindTooltip = (label) => ({
    onMouseEnter: (e) => {
      if (disabledRef.current) return

      setTooltip(makeTooltipText(label))
      setCursorPos({ x: e.clientX, y: e.clientY })

      if (hideTimerRef.current) clearTimeout(hideTimerRef.current)

      hideTimerRef.current = setTimeout(() => {
        setTooltip(null)
        disabledRef.current = true
      }, 5000)
    },
    onMouseMove: (e) => {
      if (!disabledRef.current) {
        setCursorPos({ x: e.clientX, y: e.clientY })
      }
    },
    onMouseLeave: () => {
      setTooltip(null)
      disabledRef.current = false

      if (hideTimerRef.current) {
        clearTimeout(hideTimerRef.current)
        hideTimerRef.current = null
      }
    }
  })

  return (
    <>
      <div style={gridCards}>
        <StatCard
          label={t('TRIPLOG.STATISTICS.SUMMARY.TOTAL_TRIPS')}
          value={fmtNum(stats.totalTrips)}
          {...bindTooltip(t('TRIPLOG.STATISTICS.SUMMARY.TOTAL_TRIPS'))}
        />
        <StatCard
          label={t('TRIPLOG.STATISTICS.SUMMARY.TOTAL_KM')}
          value={`${fmtNum(stats.totalKm, 2)} ${t('TRIPLOG.UNITS.KM')}`}
          {...bindTooltip(t('TRIPLOG.STATISTICS.SUMMARY.TOTAL_KM'))}
        />
        <StatCard
          label={t('TRIPLOG.STATISTICS.SUMMARY.TOTAL_COST')}
          value={`${fmtNum(stats.totalCost, 2)} ${t('TRIPLOG.UNITS.EUR')}`}
          {...bindTooltip(t('TRIPLOG.STATISTICS.SUMMARY.TOTAL_COST'))}
        />
        <StatCard
          label={t('TRIPLOG.STATISTICS.SUMMARY.TOTAL_FUEL')}
          value={`${fmtNum(stats.totalFuel, 2)} ${t('TRIPLOG.UNITS.L')}`}
          {...bindTooltip(t('TRIPLOG.STATISTICS.SUMMARY.TOTAL_FUEL'))}
        />
        <StatCard
          label={t('TRIPLOG.STATISTICS.SUMMARY.AVG_CONSUMPTION')}
          value={`${fmtNum(stats.avgConsumption, 2)} ${t('TRIPLOG.UNITS.L_PER_100KM')}`}
          {...bindTooltip(t('TRIPLOG.STATISTICS.SUMMARY.AVG_CONSUMPTION'))}
        />
        <StatCard
          label={t('TRIPLOG.STATISTICS.SUMMARY.AVG_COST_PER_KM')}
          value={`${fmtNum(stats.avgCostPerKm, 2)} ${t('TRIPLOG.UNITS.EUR')}`}
          {...bindTooltip(t('TRIPLOG.STATISTICS.SUMMARY.AVG_COST_PER_KM'))}
        />
      </div>

      {tooltip && (
        <div
          style={{
            ...tooltipPopup,
            top: cursorPos.y - 80,
            left: cursorPos.x
          }}
        >
          {tooltip}
        </div>
      )}
    </>
  )
}

export default StatsOverviewModal